// extracted by mini-css-extract-plugin
module.exports = {"root":"TableFilterIcon_root__2D_Pp","icon":"TableFilterIcon_icon__2qWFj","filtered":"TableFilterIcon_filtered__1q6qP"};